import { CheckIcon } from "lucide-react";

import type { SaveStatus } from "@/types";

export const SaveIndicator = ({ status }: { status: SaveStatus }) => {
  if (status === "idle") return null;

  if (status === "saving") {
    return <span className="text-xs text-slate-400">Saving...</span>;
  }

  return (
    <span className="inline-flex items-center gap-0.5 text-xs text-emerald-600">
      <CheckIcon className="h-3 w-3" />
      Saved
    </span>
  );
};
